export interface Comic {
  id: number;
  title: string;
  author: string;
  categories: string[];
  status: "连载" | "完结";
  latestChapter: string;
  description: string;
  rating: number;
  reads: string;
  cover: string;
}

export interface Category {
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: "萌系漫画", desc: "软萌角色 · 可爱画风", icon: "ri-emotion-happy-line", count: 386 },
  { name: "少女漫画", desc: "心动剧情 · 细腻情感", icon: "ri-heart-3-line", count: 512 },
  { name: "甜宠漫画", desc: "高甜不虐 · 双向奔赴", icon: "ri-cup-line", count: 428 },
  { name: "治愈漫画", desc: "温暖日常 · 抚慰心情", icon: "ri-sun-line", count: 264 },
  { name: "校园恋爱", desc: "青春悸动 · 纯真年代", icon: "ri-graduation-cap-line", count: 341 },
  { name: "轻松搞笑", desc: "欢乐日常 · 解压必备", icon: "ri-chat-smile-3-line", count: 198 },
  { name: "奇幻穿越", desc: "异世冒险 · 浪漫奇遇", icon: "ri-sparkling-2-line", count: 157 },
  { name: "日常轻百", desc: "温馨陪伴 · 细水长流", icon: "ri-star-smile-line", count: 132 },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: "月下恋歌",
    author: "星野小桃",
    categories: ["少女漫画", "校园恋爱", "甜宠漫画"],
    status: "连载",
    latestChapter: "更新至第 86 话",
    description: "转学生小遥在月夜天台偶遇冷面学长，一段藏在月光下的双向暗恋就此展开，青涩又高甜。",
    rating: 9.6,
    reads: "1286.4万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20shy%20schoolgirl%20with%20long%20hair%20under%20a%20soft%20crescent%20moon%20and%20sparkling%20stars%2C%20gentle%20cream%20pastel%20background%2C%20moe%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-01&orientation=portrait",
  },
  {
    id: 2,
    title: "软萌喵少女",
    author: "糖糖丸",
    categories: ["萌系漫画", "日常"],
    status: "连载",
    latestChapter: "更新至第 58 话",
    description: "总是一脸冷淡的班长，其实悄悄养着一只傲娇小奶猫，而只有转学生小林知道她的秘密。",
    rating: 9.4,
    reads: "986.2万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20with%20soft%20cat%20ears%20hugging%20a%20fluffy%20orange%20kitten%2C%20cream%20pastel%20background%2C%20moe%20cute%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-02&orientation=portrait",
  },
  {
    id: 3,
    title: "甜心小冤家",
    author: "奶盖不加冰",
    categories: ["甜宠漫画", "校园恋爱"],
    status: "连载",
    latestChapter: "更新至第 73 话",
    description: "同桌三年的欢喜冤家，嘴上互怼不停，心里却早已悄悄把对方放进未来的计划里。",
    rating: 9.5,
    reads: "1103.7万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20boy%20and%20girl%20playfully%20teasing%20each%20other%20with%20floating%20heart%20shapes%2C%20soft%20pink%20cream%20background%2C%20moe%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-03&orientation=portrait",
  },
  {
    id: 4,
    title: "樱花树下的约定",
    author: "小满同学",
    categories: ["少女漫画", "校园恋爱"],
    status: "连载",
    latestChapter: "更新至第 61 话",
    description: "毕业季的樱花树下，她许下一个十年之约。多年后再相遇，彼此都还是当初的模样。",
    rating: 9.3,
    reads: "862.5万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20boy%20and%20girl%20in%20school%20uniform%20under%20falling%20cherry%20blossoms%2C%20soft%20pink%20cream%20background%2C%20moe%20romance%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-04&orientation=portrait",
  },
  {
    id: 5,
    title: "糖果色的夏天",
    author: "汽水泡泡",
    categories: ["甜宠漫画", "治愈漫画"],
    status: "连载",
    latestChapter: "更新至第 44 话",
    description: "海边小镇的夏天，少女与邻家哥哥的甜蜜日常，每一口都是糖果色的心动。",
    rating: 9.2,
    reads: "742.1万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20smiling%20girl%20holding%20colorful%20candy%20and%20a%20popsicle%20at%20a%20summer%20beach%2C%20soft%20pastel%20cream%20background%2C%20moe%20cute%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-05&orientation=portrait",
  },
  {
    id: 6,
    title: "元气小厨娘",
    author: "布丁日记",
    categories: ["治愈漫画", "日常"],
    status: "连载",
    latestChapter: "更新至第 52 话",
    description: "白天是元气满满的少女，晚上变身治愈系小厨娘。一顿热饭，温暖一整天的疲惫。",
    rating: 9.4,
    reads: "905.8万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20cheerful%20girl%20chef%20holding%20a%20steaming%20bowl%20of%20noodles%20with%20sparkles%2C%20soft%20cream%20pastel%20background%2C%20moe%20cute%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-06&orientation=portrait",
  },
  {
    id: 7,
    title: "星语心动",
    author: "夜观星",
    categories: ["少女漫画", "校园恋爱"],
    status: "连载",
    latestChapter: "更新至第 39 话",
    description: "天文社社长与迟钝学妹，在一次次观星夜里，悄悄点亮了彼此心口的那颗星。",
    rating: 9.1,
    reads: "638.9万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20looking%20through%20a%20telescope%20at%20glowing%20stars%20and%20constellations%2C%20soft%20night%20blue%20cream%20pastel%20background%2C%20moe%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-07&orientation=portrait",
  },
  {
    id: 8,
    title: "绒绒兔的秘密",
    author: "软软棉花糖",
    categories: ["萌系漫画", "治愈漫画"],
    status: "连载",
    latestChapter: "更新至第 35 话",
    description: "性格内向的她养着一只会说话的小绒兔，从此平凡生活里多了无数软乎乎的惊喜。",
    rating: 9.3,
    reads: "721.4万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20softly%20hugging%20a%20giant%20fluffy%20white%20bunny%2C%20gentle%20cream%20pastel%20background%2C%20moe%20kawaii%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-08&orientation=portrait",
  },
  {
    id: 9,
    title: "恋爱距离一米",
    author: "一米阳光",
    categories: ["甜宠漫画", "校园恋爱"],
    status: "连载",
    latestChapter: "更新至第 67 话",
    description: "因一个打赌被迫保持一米的社交距离，可心动的信号偏偏越靠越近，甜到冒泡。",
    rating: 9.5,
    reads: "1045.3万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20boy%20and%20girl%20standing%20close%20with%20shy%20blush%20and%20floating%20hearts%2C%20soft%20pink%20cream%20background%2C%20moe%20romance%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-09&orientation=portrait",
  },
  {
    id: 10,
    title: "青梅竹马甜甜圈",
    author: "甜甜圈星球",
    categories: ["甜宠漫画", "日常"],
    status: "连载",
    latestChapter: "更新至第 48 话",
    description: "从小一起长大的青梅竹马，因为一个甜甜圈打赌，开始了一段甜度爆表的恋爱。",
    rating: 9.2,
    reads: "819.6万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20holding%20a%20donut%20and%20a%20boy%20blushing%20beside%20her%2C%20soft%20cream%20pastel%20background%2C%20moe%20cute%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-10&orientation=portrait",
  },
  {
    id: 11,
    title: "治愈系小森林",
    author: "微风与苔",
    categories: ["治愈漫画", "日常"],
    status: "完结",
    latestChapter: "已完结 · 共 120 话",
    description: "搬到森林边的女孩，与花花草草、小动物们一起生活的温暖故事，看完满满治愈。",
    rating: 9.6,
    reads: "1520.8万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20surrounded%20by%20green%20leaves%20flowers%20and%20tiny%20forest%20animals%2C%20soft%20mint%20cream%20pastel%20background%2C%20moe%20healing%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-11&orientation=portrait",
  },
  {
    id: 12,
    title: "心动信号满格",
    author: "信号接收中",
    categories: ["少女漫画", "甜宠漫画"],
    status: "连载",
    latestChapter: "更新至第 55 话",
    description: "当手机里的心动信号连续满格，迟钝的女主角才后知后觉——原来那个人一直都在。",
    rating: 9.3,
    reads: "934.2万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20holding%20a%20phone%20with%20glowing%20heart%20signal%20bars%20and%20sparkles%2C%20soft%20pink%20cream%20background%2C%20moe%20cute%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-12&orientation=portrait",
  },
  {
    id: 13,
    title: "呆萌小福星",
    author: "好运连连",
    categories: ["萌系漫画", "轻松搞笑"],
    status: "连载",
    latestChapter: "更新至第 42 话",
    description: "迷迷糊糊的小福星身边总发生奇妙的好事，欢乐又治愈的日常让人会心一笑。",
    rating: 9.1,
    reads: "667.5万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20an%20adorable%20clumsy%20girl%20with%20a%20lucky%20panda%20mascot%20and%20sparkling%20clovers%2C%20soft%20cream%20pastel%20background%2C%20moe%20kawaii%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-13&orientation=portrait",
  },
  {
    id: 14,
    title: "初雪告白书",
    author: "糖霜小麋鹿",
    categories: ["少女漫画", "甜宠漫画"],
    status: "完结",
    latestChapter: "已完结 · 共 98 话",
    description: "第一场初雪落下的日子，一封没有署名的告白书，牵起了两个少年少女整整三年的暗恋。",
    rating: 9.5,
    reads: "1318.9万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20in%20a%20scarf%20holding%20a%20love%20letter%20under%20soft%20snowfall%20with%20warm%20lanterns%2C%20gentle%20cream%20pastel%20background%2C%20moe%20romance%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-14&orientation=portrait",
  },
  {
    id: 15,
    title: "云端恋爱小事",
    author: "云朵泡芙",
    categories: ["甜宠漫画", "治愈漫画"],
    status: "完结",
    latestChapter: "已完结 · 共 90 话",
    description: "两位温柔慢热的大人，在云端般柔软的日子里，把每一件小事都过成了甜甜的恋爱。",
    rating: 9.2,
    reads: "784.3万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20gently%20smiling%20couple%20lying%20among%20soft%20clouds%20in%20the%20sky%2C%20dreamy%20cream%20pastel%20background%2C%20moe%20romance%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-15&orientation=portrait",
  },
  {
    id: 16,
    title: "蒲公英的信",
    author: "晚风邮局",
    categories: ["少女漫画", "治愈漫画"],
    status: "完结",
    latestChapter: "已完结 · 共 76 话",
    description: "用蒲公英当作信使传递心意的少女，在漫长岁月里等来了一场温柔的回信。",
    rating: 9.4,
    reads: "956.7万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20girl%20blowing%20dandelion%20seeds%20into%20a%20gentle%20breeze%2C%20soft%20mint%20cream%20pastel%20background%2C%20moe%20healing%20style%2C%20high%20detail%2C%20clean%20composition&width=600&height=800&seq=keke-cover-16&orientation=portrait",
  },
];